import request from'@/utils/request.js'

export default{
    Query(data) {
        return request({
            url: '/News/Query',
            method: 'post',
            data
        })
    }    
} 